// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3rP8Z","consentsList":"PatientConsents_consentsList__3owh2","consentsListEmpty":"PatientConsents_consentsListEmpty__2OVFY"};